module.exports = __webpack_public_path__ + "img/nointernet1.2b8dd524.svg";